import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomTextCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m6.586-5.039h4.93c.285 0 .56.113.758.317l2.597 2.592c.204.199.317.473.317.757v4.922c0 .59-.484 1.073-1.075 1.073H8.586a1.077 1.077 0 0 1-1.076-1.073V8.035c0-.59.484-1.074 1.076-1.074m5.914 6.44h-4.301a.54.54 0 0 0-.538.537c0 .296.242.537.538.537h4.3a.54.54 0 0 0 .539-.537.54.54 0 0 0-.538-.536Zm0-2.146h-4.301a.54.54 0 0 0-.538.537c0 .295.242.536.538.536h4.3a.54.54 0 0 0 .539-.536.54.54 0 0 0-.538-.537m-1.613-2.651h-2.688c-.296 0-.538.3-.538 1.04a.54.54 0 0 0 .538.538h2.688c.296 0 1.02 0 1.02-.537 0-.72-.724-1.041-1.02-1.041"
  />,
  'CustomTextCircular',
);

export default CustomTextCircular;
